document.addEventListener('change', function(event) {
  // Check if the changed element is one of your filter checkboxes
  if (event.target.matches('input[name="filter.p.tag"]')) {
    const selectedTags = [];
    // Get all checked filter checkboxes
    document.querySelectorAll('input[name="filter.p.tag"]:checked').forEach(checkbox => {
      selectedTags.push(checkbox.value);
    });

    // Construct the new URL
    let newUrl = window.location.pathname; // Starts with the base path
    if (selectedTags.length > 0) {
      const params = new URLSearchParams();
      selectedTags.forEach(tag => {
          // Shopify expects tags to be URL-encoded for safety, URLSearchParams handles this
          params.append('filter.p.tag', tag);
      });
      // Corrected line using template literal (backticks)
      newUrl = `${newUrl}?${params.toString()}`;
    } else {
      // If no tags are selected, navigate back to the base collection URL
      newUrl = window.location.pathname;
    }

    // Navigate to the new URL to apply filters
    window.location.href = newUrl;

    // For AJAX filtering (more advanced, better UX):
    // Instead of window.location.href, you would use fetch API
    // to get the filtered products and update the product grid area.
    // This requires more complex JS to swap out content.
  }
});


  document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    const selectedTags = urlParams.getAll('filter.p.tag');

    selectedTags.forEach(tag => {
      const checkbox = document.querySelector(`input[name="filter.p.tag"][value="${CSS.escape(tag)}"]`);
      if (checkbox) {
        checkbox.checked = true;
      }
    });
  });

